/**
 * Chain photos for the pendant-market pages (sections/hs-chain-photos.liquid).
 * Hands the chain photo list to <henley-product-page> (henley-product.js) so
 * its gallery only shows the chosen chain's photos, and adds the
 * "4mm Cuban chain pictured" label to the main image and mobile slides.
 *
 * Gallery order is always: product, model, product, model, then any model
 * photos left over, and the gift pouch last. Whichever runs out first, the
 * other simply carries on, so a chain with one product shot or a product
 * with no model shots still reads correctly. The chain lists hold only
 * product photography, so model shots can be added or removed without
 * touching them.
 *
 * Pendant Only shows the pendant-only cut-out first (Shopify Files
 * hs-pendant-zoom-<key>.webp), then the model photos (8L3A… files).
 */
(function () {
  var dataEl = document.querySelector('[data-hs-chain-photos]');
  if (!dataEl) return;
  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!data.media || !data.media.length) return;

  var labels = {};
  data.media.forEach(function (m) {
    if (m.label) labels[m.src] = m.label;
  });

  function fileName(m) {
    return m.src.split('?')[0].split('/').pop().toLowerCase();
  }

  // product, model, product, model, remaining models, pouch last
  function interleave(list) {
    var own = [];
    var models = [];
    var tail = [];
    list.forEach(function (m) {
      if (m.group) own.push(m);
      else if (fileName(m).indexOf('pouch') !== -1) tail.push(m);
      else models.push(m);
    });
    if (!own.length) return list;
    var out = [];
    var i = 0;
    var j = 0;
    while (i < own.length || j < models.length) {
      if (i < own.length) out.push(own[i++]);
      if (j < models.length) out.push(models[j++]);
    }
    return out.concat(tail);
  }

  function sameOrder(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function setup(page) {
    if (page.dataset.hsChainPhotos) return;
    page.dataset.hsChainPhotos = 'true';

    page.mediaList = data.media;
    page.mediaGroupValues = data.groups;
    page.groupOptionPosition = data.position;

    // Pendant Only: cut-out first, then the model photos, no chain shots
    var FILES = 'https://cdn.shopify.com/s/files/1/0888/2366/0873/files/';
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    var key = handle.replace('-market', '').replace('-silver-pairing', '').replace('-gold-pairing', '').replace('-pendant', '');
    var cutout = FILES + 'hs-pendant-zoom-' + key + '.webp';
    // one of each model photo, keeping the copy that has a "Model wearing" label
    var seen = {};
    var models = [];
    data.media.forEach(function (m) {
      var f = (m.src.split('?')[0].split('/').pop().match(/8L3A\d+/) || [])[0];
      if (!f) return;
      if (!(f in seen)) {
        seen[f] = models.length;
        models.push(m);
      } else if (m.label && !models[seen[f]].label) {
        models[seen[f]] = m;
      }
    });
    var pendantOnly = [{ id: 'hs-pendant-only', group: '', label: '', src: cutout, thumb: cutout, lightbox: cutout, alt: document.title }].concat(models);
    new Image().src = cutout;
    var baseFilter = page.applyVariantMediaFilter.bind(page);
    page.applyVariantMediaFilter = function (variant) {
      var value = String(page.selectedOptions[data.position - 1] || '').toLowerCase();
      if (key && value.indexOf('pendant only') !== -1) {
        page.activeMedia = pendantOnly.slice();
        page.renderGallery();
        return;
      }
      baseFilter(variant);
      var ordered = interleave(page.activeMedia);
      if (!sameOrder(ordered, page.activeMedia)) {
        page.activeMedia = ordered;
        page.renderGallery();
      }
    };
    data.media.forEach(function (m) {
      new Image().src = m.src;
    });

    var main = page.querySelector('[data-henley-main-img]');
    var wrap = page.querySelector('.henley-main-img-wrap');
    var tag = document.createElement('span');
    tag.className = 'hs-chain-pic-label';
    tag.hidden = true;
    if (wrap) wrap.appendChild(tag);

    // the cut-out shows at half size on its own grey (hayden 2026-10-22)
    var css = document.createElement('style');
    css.textContent = 'img.hs-po-cut{object-fit:contain;padding:25%;box-sizing:border-box;background:#ebebeb}';
    document.head.appendChild(css);

    function updateMain() {
      if (!main) return;
      main.classList.toggle('hs-po-cut', main.getAttribute('src') === cutout);
      var label = labels[main.getAttribute('src')] || '';
      tag.textContent = label;
      tag.hidden = !label;
    }
    if (main) new MutationObserver(updateMain).observe(main, { attributes: true, attributeFilter: ['src'] });

    var track = page.querySelector('[data-henley-mobile-track]');
    function updateSlides() {
      track.querySelectorAll('.henley-mobile-slide').forEach(function (slide) {
        var img = slide.querySelector('img');
        if (img && img.getAttribute('src') === cutout) img.classList.add('hs-po-cut');
        if (slide.querySelector('.hs-chain-pic-label')) return;
        var label = img && labels[img.getAttribute('src')];
        if (!label) return;
        var span = document.createElement('span');
        span.className = 'hs-chain-pic-label';
        span.textContent = label;
        slide.appendChild(span);
      });
    }
    if (track) new MutationObserver(updateSlides).observe(track, { childList: true });

    // Same call henley-product.js makes on load and on every chain change
    page.applyVariantMediaFilter(page.findMatchingVariant());
    updateMain();
    if (track) updateSlides();
  }

  function run() {
    var page = document.querySelector('henley-product-page');
    if (!page) return;
    customElements.whenDefined('henley-product-page').then(function () {
      // connectedCallback has run once mediaList exists
      if (page.mediaList) {
        setup(page);
      } else {
        var tries = 0;
        var timer = setInterval(function () {
          if (page.mediaList || ++tries > 50) {
            clearInterval(timer);
            if (page.mediaList) setup(page);
          }
        }, 50);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();